// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".loadingSpinnerWrapper--1PlC9 {\n  height: 300px;\n}\n", ""]);
// Exports
exports.locals = {
	"loadingSpinnerWrapper": "loadingSpinnerWrapper--1PlC9"
};
module.exports = exports;
